export class IstanzaVendita {
  id: string;
  vendita: boolean;
  ricavato: number | string;
  acquirente: string;
  dataIstanza: number;
}
